const throwNewError = (errorMessage: string | undefined) => {
    throw new Error(errorMessage ?? 'Generic API error')
}

export { throwNewError }